import { Injectable, inject } from '@angular/core';
import { HttpCoreService } from '@dataclouder/ngx-core';

import { GenerateImageRequest } from './models/video-generation.model';

// Placeholder for the response type, adjust as needed

// I need to think who will get this if agent chat or vertex, in order to dont create new classes.

export enum ChatRoleVertex {
  System = 'system',
  User = 'user',
  Assistant = 'assistant',
}

export class ChatMessage {
  role: ChatRoleVertex;
  content: string;
}

@Injectable({
  providedIn: 'root',
})
export class NgxVertexService {
  private httpCore = inject(HttpCoreService);

  constructor() {}

  // Example method - replace with actual API calls
  async callVertexApi<T = any>(endpoint: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE', data?: any): Promise<T> {
    const servicePath = `api/vertex/${endpoint}`; // Adjust base path if needed

    switch (method) {
      case 'GET':
        return this.httpCore.get<T>(servicePath);
      case 'POST':
        return this.httpCore.post<T>(servicePath, data);
      case 'PUT':
        return this.httpCore.put<T>(servicePath, data);
      case 'DELETE':
        return this.httpCore.delete<T>(servicePath);
      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }
  }

  async generateImage(request: GenerateImageRequest, local: boolean = false): Promise<any> {
    // Assuming 'generate-image' is the correct endpoint suffix

    const endpoint = local ? 'generate-image?provider=local' : 'generate-image';

    return this.callVertexApi(endpoint, 'POST', request);
  }

  async generateText(request: ChatMessage[]): Promise<any> {
    // Assuming 'generate-text' is the correct endpoint suffix
    return this.callVertexApi('gemini/generate-text', 'POST', request);
  }

  async listImageModels(local: boolean = false): Promise<any> {
    const endpoint = local ? 'list-models?provider=local' : 'list-models';
    return this.callVertexApi(endpoint, 'GET');
  }
}
